import clsx from "clsx";
import type { TextareaHTMLAttributes } from "react";
import { Text } from "../Text";
import styles from "./textarea.module.scss";

export interface TextAreaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  id?: string;
  label?: string;
  outlined?: boolean;
  onRightIconClick?: () => void;
  errors?: string[];
  helperText?: string;
}

export const TextArea = ({
  id = "textarea",
  label,
  outlined = false,
  errors,
  helperText,
  ...rest
}: TextAreaProps) => {
  const hasError = errors && errors.length > 0;

  const containerClassName = clsx(
    styles.textAreaContainer,
    outlined && styles.outlined,
    hasError && styles.error
  );

  return (
    <div className={styles.root}>
      {label && (
        <Text className={styles.label} as="label" htmlFor={id} variant="small">
          {label}
        </Text>
      )}
      <div className={containerClassName}>
        <textarea
          id={id}
          {...rest}
          className={clsx([styles.textArea, rest.className])}
        />
      </div>
      {helperText && !hasError && (
        <Text className={styles.helperText} variant="xsmall">
          {helperText}
        </Text>
      )}
      {errors?.map((error) => (
        <Text key={error} className={styles.errorMessage} variant="xsmall">
          {error}
        </Text>
      ))}
    </div>
  );
};
